<template>
    <div class="animated fadeIn">
      <div class="viewMode">
        <b-row class="mb-2">
          <b-col cols="12">
            <h1>Vehicle Plate Orders</h1>
          </b-col>
        </b-row>
        <b-row v-if="canSelectOtherSites">
          <b-col sm="12">
            <b-card>
              <div slot="header">
                  <strong>Select Site</strong>
              </div>
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="company">Company</label>
                    <b-form-select id="company" v-if="companiesLoaded"  v-model="filterParams.company_id"
                      :plain="true"
                      :options="companies"
                      :disabled="!isMinimumSuperAdmin">
                    </b-form-select>
                    <div v-if="!companiesLoaded" >
                      <i class="fa fa-spin fa-spinner"></i>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="area">Area</label>
                    <b-form-select id="area" v-if="areasLoaded"  v-model="filterParams.area_id"
                      :plain="true"
                      :options="areas"
                      :disabled="!isMinimumCompanyUser">
                    </b-form-select>
                    <div v-if="!areasLoaded" >
                      <i class="fa fa-spin fa-spinner"></i> Waiting for company selection
                    </div>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="site">Site</label>
                    <b-form-select id="site" v-if="sitesLoaded"  v-model="filterParams.site_id"
                      :plain="true"
                      :options="sites"
                      :disabled="!isMinimumAreaUser">
                    </b-form-select>
                    <div v-if="!sitesLoaded" >
                      <i class="fa fa-spin fa-spinner"></i> Waiting for area selection
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="ordersCount == 0 && hasFetchingOrdersCompleted">
          <b-col>
            <h3>No Orders available</h3>
            <p>
              There are no orders to view. To create a new order, click here.
            </p>
          </b-col>
        </b-row>
        <div v-if="!hasFetchingOrdersCompleted && siteChosen">
          <b-row>
            <b-col>
              <LoadingSpinner />
            </b-col>
          </b-row>
        </div>
        <div v-if="ordersCount > 0 && hasFetchingOrdersCompleted && siteChosen">
          <b-row>
            <b-col cols="12">
              <h3>Items: {{ ordersCount}}</h3>
            </b-col>
            <b-col v-for="order in orders" cols="12" sm="12" v-bind:key="order.id">
              <b-card>
                <div slot="header">
                  <b-row>
                    <b-col sm="7">
                      Order placed: <strong>{{ order.formattedDate }}</strong><br />
                      Ordered by: <strong>{{ order.ordered_by.first_name + ' ' + order.ordered_by.last_name }}</strong> - 
                      <strong>{{ order.ordered_by.email }}</strong>
                    </b-col>
                    <b-col class="right-text" sm="5">
                      Order number: <strong>PP-0{{ order.id }}</strong><br />
                      Site: <strong>{{ order.site.site_name }}</strong>
                    </b-col>
                  </b-row>
                </div>
                <b-card-body class="p-3 clearfix card-body">
                  <div class="items-body" v-for="orderItem in order.mup_order_items" v-bind:key="orderItem.id">
                    <div class="item-details">                  
                      <div class="h5 text-warning mb-0">
                        Registration Number: <span class="text-muted">{{orderItem.registration_number}}</span>
                      </div>
                      <div class="font-weight-bold text-warning mb-0">
                        Plate Size: <span class="text-muted">{{orderItem.plate_width}}mm x {{orderItem.plate_height}}mm </span>
                      </div>
                      <div class="font-weight-bold text-warning mb-0">
                        Slogan: <span class="text-muted">{{orderItem.slogan}}</span>
                      </div>
                      <div class="font-weight-bold text-warning mb-0">
                        Postcode: <span class="text-muted">{{orderItem.postcode}}</span>
                      </div>
                      <div class="font-weight-bold text-warning mb-0">
                        Border: <span class="text-muted">{{orderItem.is_border ? 'Yes' : ' No'}}</span>
                      </div>
                      <div class="font-weight-bold text-warning mb-0">
                        Flag: <span class="text-muted capitalise">{{orderItem.flag_colour}}</span>
                      </div>
                      <div class="font-weight-bold text-warning mb-0">
                        Plate Position: <span class="text-muted capitalise">{{orderItem.plate_type}}</span>
                      </div>
                    </div>
                    <div class="item-images">
                      <img v-bind:src="orderItem.image" class="basket-image" />
                    </div>
                  </div>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
</template>

<script>

import LoadingSpinner from '../../components/loadingSpinner/LoadingSpinner';
import MUPService from '@/services/mup-service.js';
import LookupDataService from '@/services/lookup-data-service.js';
import moment from 'moment';

export default {
  name: 'vehiclePlateOrders',
  components: {
      LoadingSpinner: LoadingSpinner,
  },
  data () {
    return {
      userObj: '',
      orders: [],
      hasFetchingOrdersCompleted: false,
      userAuthLevel: '',
      filterParams: {
        company_id: -1,
        area_id: -1,
        site_id: -1,
      },
      companies: [],
      areas: [],
      sites: [],
      companiesLoaded: false,
      areasLoaded: false,
      sitesLoaded: false,
      siteChosen: false
    }
  },
  async created () {
    // get the logged in user
    const userObj = JSON.parse(localStorage.getItem('user'));
    this.$data.userObj = userObj;

    // get the site and supplier id and the address
    this.$data.filterParams.company_id = userObj.company_id;
    this.$data.filterParams.area_id = userObj.area_id;
    this.$data.filterParams.site_id = userObj.site_id;
    this.$data.userAuthLevel = userObj.auth;

    this.getInitialData();

    // const orders = await MUPService.getOrders(filter);
    // this.$data.orders = orders.map((order) => {
    //   order.formattedDate = moment(order.created_at).format("lll");
    //   return order;
    // });
    // this.$data.hasFetchingOrdersCompleted = true;
  },
  watch: {
    'filterParams.company_id': async function(val, oldVal) {
      // get the branches for the selected company
      // clear it out first
      this.$data.areas = [];
      this.$data.sites = [];

      const areaList = await LookupDataService.getAreaList(val);
      if (this.$data.userAuthLevel == 'Super Admin' || this.$data.userAuthLevel == 'Company Users') {
        this.$data.areas.push({value:0, text: 'Select Area...'});
        this.$data.filterParams.area_id = 0;
        this.$data.filterParams.site_id = 0;
      }
      areaList.map((item) => {
        this.$data.areas.push(item);
      });
      this.$data.areasLoaded = true;
    },
    'filterParams.area_id': async function(val, oldVal) {
      // clear it out first
      this.$data.sites = [];
      this.$data.sites.push({value:0, text: 'Select Site...'});
      this.$data.filterParams.site_id = 0;

      if (parseInt(val) > 0) {
        const sitesList = await LookupDataService.getSiteList(val);
        sitesList.map((item) => {
          this.$data.sites.push(item);
        });
        this.$data.sitesLoaded = true;
      }
    },
    'filterParams.site_id': function(val, oldVal) {
      this.$data.filterParams.site_id = val;
      try {
        //this.$data.siteChosenName = this.$data.sites.filter(s => s.value == val)[0].text;
        if (val > 0) {
          this.getOrders();
          this.$data.siteChosen = true;
        }
        else {
          this.$data.siteChosen = false;
        }
      }
      catch (e) {
        //this.$data.siteChosenName = '';
      }
    },
  },
  computed: {
    isMinimumSuperAdmin() {
      let returnVal = false;
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      
      return returnVal;
    },
    isMinimumCompanyUser() {
      let returnVal = false;
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Company Users':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      return returnVal;
    },
    isMinimumAreaUser() {
      let returnVal = false;
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Company Users':
        case 'Area Users':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      return returnVal;
    },
    isMinimumSiteUser() {
      let returnVal = false;
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Company Users':
        case 'Area Users':
        case 'Site Users':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      
      return returnVal;
    },
    ordersCount() {
      try {
        return this.$data.orders.length;
      }
      catch(e) {
        return 0;
      }
    },
    canSelectOtherSites() {
      let returnVal = false;
      
      if (
        this.$data.userObj.auth == 'Super Admin' || this.$data.userObj.auth == 'Company Users' ||
        this.$data.userObj.auth == 'Area Users' || this.$data.userObj.auth == 'Site Users'
        ) {
        returnVal = true;
      }
      
      return returnVal;
    },
  },
  methods : {
    async getInitialData() {
      const companies = await LookupDataService.getCompaniesList();
      this.$data.companies = companies;
      this.$data.companiesLoaded = true;
    },
    async getOrders() {
      const filter = {
        company_id: this.$data.filterParams.company_id,
        area_id: this.$data.filterParams.area_id,
        site_id: this.$data.filterParams.site_id
      }
      const orders = await MUPService.getOrders(filter);
      this.$data.orders = orders.map((order) => {
        order.formattedDate = moment(order.created_at).format("lll");
        return order;
      });
      this.$data.hasFetchingOrdersCompleted = true;
    }
  }
}
</script>

<style scoped>
.capitalise {
  text-transform: capitalize;
}
.delete-item-button {
  position: absolute;
  right: 5%;
  top: 15%;
}
.action-button-bar {
  text-align: right;
}
.terms-button {
  margin-left: 10px;
}
img.basket-image {
  max-width: 200px;
}
div.item-details {
  flex-grow: 0;
  margin-bottom: 20px;
}
div.item-images {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
}
.items-body {
  display: flex;
  column-gap: 1.5rem;
  background-color: #f1f1f1;
}
.card-body {
  background-color: #f1f1f1;
}

</style>
